import type { Ref } from 'vue'

import { useElementSize } from '@vueuse/core'

import { useRootPxVar } from '~/scopes/campaign/composables/useRootPxVar'

/**
 * Publishes a target element's live border-box height to a CSS custom property
 * on <html>, so floating panels can sit clear of it without magic numbers.
 */
export function useElementHeightVar(
  target: Ref<HTMLElement | null>,
  cssVar: string,
) {
  const { height } = useElementSize(
    target,
    { width: 0, height: 0 },
    { box: 'border-box' },
  )
  useRootPxVar(height, cssVar)
}
